/**
* Component PresentationCard
*
* Display an anchor, a title, a description of elements with smart list, a button to popup and a picture
*
* Props : 
* - anchor (String), title (String) :  text and title for the "MainTitle" component
* - listItem1, listItem2, listItem3  (String) : smart list to describe the element
* - MoreInformationUrl (String), MoreInformationText (String) : url and text button for the "PageLink" component
* - item_alt : text alternative if the image not display
* - item_url : url of the image to display
*
* Intern component : 
* - MainTitle : component to manage title and description of an element
* - PopupButton : component to manage the popup open. Here "PresentationCard" relaye the event to "RoomView"
*/


<template>
  <div 
  class="discover_component" 
  data-aos="fade-up" 
  data-aos-duration="1000" 
  data-aos-easing="ease-in-out"  
  data-aos-once="true"
  >
    <MainTitle :anchor="anchor" :title="title"/>
    <ul class="item_list">
      <li
      v-for="(item, itemIndex) in items"
      :key=itemIndex
      >
      {{ item }}
      </li>
    </ul>
    <PopupButton :id="id" @show-more="$emit('show-more', $event)" /> <!-- Send the event "show-more"-->

 <!-- Slider -->
    <div class="slider_container">
      <button class="nav-button left" @click="prevImage">&#10094;</button>
      <img
        class="item_img"
        :src="item_url[currentImage]"
        :alt="item_alt"
      />
      <button class="nav-button right" @click="nextImage">&#10095;</button>
    </div>
    <div>
</div>
  </div>
</template>

<script>
import MainTitle from "@/components/MainTitle.vue";
import PopupButton from "./PopupButton.vue";

export default {
  name: "PresentationCard",
  components: { MainTitle, PopupButton },
  props: {
    anchor: String,
    title:String,
    items: {
      type: Array,
      required: true,
       default: () => [],
    },
    MoreInformationText:String,
    MoreInformationUrl:String,
    item_alt:String,
    item_url:[String, Array],
    id:String
  },
  data() {
    return {
      currentImage: 0,
    };
},
 methods: {
    nextImage() {
      this.currentImage =
        (this.currentImage + 1) % this.item_url.length;
    },
    prevImage() {
      this.currentImage =
        (this.currentImage - 1 + this.item_url.length) %
        this.item_url.length;
    },
  },
};
</script>

<style lang="scss">
@import "../assets/styles/_variables.scss";

.item_list{
  margin-left: -10px;

}

.slider_container {
  position: relative;
  max-width: 21rem;

}

.item_img{
    width: 100%;
    max-width: 21rem;
    max-height: 18rem;
    margin-top: $spacing-large;

}
.nav-button {
  position: absolute;
  top: 50%;
  border: none;
  font-size: 1rem;
  padding: 6px 10px;
  cursor: pointer;
  border-radius: 80%;
  z-index: 1;
  transition: background 0.2s ease;
  background-color: transparent;
}

.nav-button.left {
  left: 0.3rem;
}

.nav-button.right {
  right: 0.3rem;
}

.nav-button:hover {
  background-color: rgba(0, 0, 0, 0.6);
  color: white;
}
</style>
